import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
type ReviewType = {
    paragraph: string;
};

type ReviewPropsType = {
    title: string;
    list: ReviewType[];
    author: string;
    logoSrc: string;
};

const Review = ({ title, list, author, logoSrc }: ReviewPropsType) => {
    return (
        <div className="client-review">
            <FullWrapper>
                <div className="client-reviewWrapper">
                    <div className="client-reviewTitle">{title}</div>
                    <div className="client-reviewMiddle">
                        {list.map(({ paragraph }, index) => (
                            <div
                                key={index}
                                className="client-reviewParagraf"
                                dangerouslySetInnerHTML={{ __html: paragraph }}
                            ></div>
                        ))}
                    </div>
                    <div className="client-reviewBottom">
                        <div className="client-reviewBottomInfo">
                            <div
                                className="client-reviewBottomAuthor"
                                dangerouslySetInnerHTML={{ __html: author }}
                            ></div>
                        </div>
                        <img src={logoSrc} alt="reviewLogo" className="client-reviewBottomLogo" />
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Review;
